import Layout from '@/views/layout'

export default {
  path: '/manage',
  name: 'Manage',
  meta: {
    // 账户管理作为公共权限路由，这里设置一个自定义的 PlaceholderCode 值
    id: 'PlaceholderCode',
    title: '账户管理'
  },
  component: Layout,
  children: [
    {
      path: 'business',
      name: 'BusinessManage',
      meta: {
        id: 'PlaceholderCode',
        title: '业务管理'
      },
      component: () => import('@/views/accountManage'),
      children: [
        // 交易明细查询
        {
          path: 'transaction-detail',
          name: 'TransactionDetail',
          meta: {
            id: '10100100',
            title: '交易明细查询'
          },
          component: () => import('@/views/accountManage/business/transactionDetail/Index.vue'),
          children: []
        },
        // 对账单下载
        {
          path: 'download-bill',
          name: 'DownloadBill',
          meta: {
            id: '10102500',
            title: '对账单下载'
          },
          component: () => import('@/views/accountManage/business/downloadBill/Index.vue'),
          children: []
        },
        // 审核指令处理
        {
          path: 'directive-deal',
          name: 'DirectiveDeal',
          meta: {
            id: '10800000',
            title: '审核指令处理'
          },
          component: () => import('@/views/accountManage/business'),
          redirect: '/manage/business/directive-deal/query',
          children: [
            {
              path: 'query',
              name: 'DirectiveDealQuery',
              component: () => import('@/views/accountManage/business/directiveDeal/Index.vue')
            },
            {
              path: 'order-list',
              name: 'DirectiveDealQueryOrderList',
              component: () => import('@/views/accountManage/business/directiveDeal/OrderList.vue')
            },
            {
              path: 'order-detail',
              name: 'DirectiveDealQueryOrderDetail',
              component: () => import('@/views/accountManage/components/OrderDetail.vue')
            },
            {
              path: 'deal-result',
              name: 'DirectiveDealResult',
              component: () => import('@/views/accountManage/business/directiveDeal/Result.vue')
            }
          ]
        },
        // 审核指令查询
        {
          path: 'directive-query',
          name: 'DirectiveQuery',
          meta: {
            id: '11100000',
            title: '审核指令查询'
          },
          component: () => import('@/views/accountManage/business'),
          redirect: '/manage/business/directive-query/list',
          children: [
            {
              path: 'list',
              name: 'DirectiveQueryList',
              component: () => import('@/views/accountManage/business/directiveQuery/Index')
            },
            {
              path: 'order-detail',
              name: 'DirectiveQueryOrderDetail',
              component: () => import('@/views/accountManage/components/OrderDetail.vue')
            }
          ]
        }
      ]
    },
    {
      path: 'info',
      name: 'InfoManage',
      meta: {
        id: '999',
        title: '基本信息管理'
      },
      component: () => import('@/views/accountManage'),
      children: [
        // 账户信息查询
        {
          path: 'account-info',
          name: 'AccountInfo',
          meta: {
            id: '10100000',
            title: '账户信息查询'
          },
          component: () => import('@/views/accountManage/info'),
          redirect: '/manage/info/account-info/list',
          children: [
            {
              path: 'list',
              name: 'AccountInfoList',
              meta: {
                title: ''
              },
              component: () => import('@/views/accountManage/info/accountInfo/List')
            },
            // 设置账户别名
            {
              path: 'set-alias',
              name: 'SetAccountAlias',
              meta: {
                title: '设置账户别名'
              },
              component: () => import('@/views/accountManage/info/accountInfo/SetAccountAlias')
            }
          ]
        },
        // 登录密码修改
        {
          path: 'modify-pwd',
          name: 'ModifyPwd',
          meta: {
            id: '10700100',
            title: '登录密码修改'
          },
          component: () => import('@/views/accountManage/info'),
          redirect: '/manage/info/modify-pwd/submit',
          children: [{
            path: 'submit',
            name: 'ModifyPwdSubmit',
            component: () => import('@/views/accountManage/info/modifyPwd/ModifyPwdSubmit')
          }]
        },
        // 企业基本信息
        {
          path: 'basic-info',
          name: 'BasicInfo',
          meta: {
            id: '10700700',
            title: '企业基本信息'
          },
          component: () => import('@/views/accountManage/info/basicInfo'),
          children: []
        },
        // 新币种账户申请
        {
          path: 'electronic-account-opening',
          name: 'ElectronicAccountOpening',
          meta: {
            id: '10101234',
            title: '新币种账户申请'
          },
          component: () => import('@/views/accountManage/info'),
          redirect: '/manage/info/electronic-account-opening/submit',
          children: [
            {
              path: 'submit',
              name: 'ElectronicAccountOpeningSubmit',
              component: () => import('@/views/accountManage/info/electronicAccountOpening/ElectronicAccountOpeningSubmit')
            },
            {
              path: 'confirm',
              name: 'ElectronicAccountOpeningConfirm',
              component: () => import('@/views/accountManage/info/electronicAccountOpening/ElectronicAccountOpeningConfirm')
            },
            {
              path: 'result',
              name: 'ElectronicAccountOpeningResult',
              component: () => import('@/views/accountManage/info/electronicAccountOpening/ElectronicAccountOpeningResult')
            }
          ]
        },
        // 地址管理
        {
          path: 'contact-address',
          name: 'ContactAddress',
          meta: {
            id: '15000100',
            title: '地址管理'
          },
          component: () => import('@/views/accountManage/info/contactAddress/index')
        }
      ]
    },
    {
      path: 'security',
      name: 'SecurityManage',
      meta: {
        id: '107',
        title: '安全管理'
      },
      component: () => import('@/views/accountManage'),
      children: [
        // 账户限额设置
        {
          path: 'limit-amount',
          name: 'LimitAmount',
          meta: {
            id: '10700600',
            title: '账户限额设置'
          },
          component: () => import('@/views/accountManage/security'),
          redirect: '/manage/security/limit-amount/list',
          children: [
            {
              path: 'list',
              name: 'SecurityLimitAmountList',
              meta: {
                title: ''
              },
              component: () => import('@/views/accountManage/security/limitAmount/list')
            },
            {
              path: 'update',
              name: 'SecurityLimitAmountUpdate',
              meta: {
                title: '修改'
              },
              component: () => import('@/views/accountManage/security/limitAmount/update')
            },
            {
              path: 'result',
              name: 'SecurityLimitAmountResult',
              meta: {
                title: '结果'
              },
              component: () => import('@/views/accountManage/security/limitAmount/result')
            }
          ]
        },
        // 企业管理授权
        {
          path: 'auth-manage',
          name: 'AuthManage',
          meta: {
            id: '10700500',
            title: '企业管理授权'
          },
          component: () => import('@/views/accountManage/security'),
          redirect: '/manage/security/auth-manage/list',
          children: [{
            path: 'list',
            name: 'EnterpriseAuthManageList',
            component: () => import('@/views/accountManage/security/authManage/EnterpriseAuthManageList')
          },
          {
            path: 'order-list',
            name: 'EnterpriseAuthManageOrderList',
            component: () => import('@/views/accountManage/security/authManage/EnterpriseAuthManageOrderList')
          },
          {
            path: 'detail-10700000',
            name: 'EnterpriseAuthManageDetail10700000',
            component: () => import('@/views/accountManage/security/authManage/EnterpriseAuthManageDetail10700000')
          },
          {
            path: 'detail-10700600',
            name: 'EnterpriseAuthManageDetail10700600',
            component: () => import('@/views/accountManage/security/authManage/EnterpriseAuthManageDetail10700600')
          },
          {
            path: 'result',
            name: 'EnterpriseAuthManageResult',
            component: () => import('@/views/accountManage/security/authManage/EnterpriseAuthManageResult')
          }]
        },
        // 用户号维护
        {
          path: 'number-maintain',
          name: 'NumberMaintain',
          meta: {
            id: '10700000',
            title: '用户号维护'
          },
          component: () => import('@/views/accountManage/security'),
          redirect: '/manage/security/number-maintain/list',
          children: [
            {
              path: 'list',
              name: 'NumberMaintainList',
              meta: {
                title: ''
              },
              component: () => import('@/views/accountManage/security/numberMaintain/NumberMaintainList')
            },
            {
              path: 'tabs',
              name: 'NumberMaintainModifyTabs',
              meta: {
                title: ''
              },
              component: () => import('@/views/accountManage/security/numberMaintain/NumberMaintainModifyTabs')
            },
            {
              path: 'result',
              name: 'NumberMaintainModifyResult',
              meta: {
                title: ''
              },
              component: () => import('@/views/accountManage/security/numberMaintain/NumberMaintainModifyResult')
            }
          ]
        },
        // 密码重置审批
        {
          path: 'reset-pwd',
          name: 'ResetPasswordApproval',
          meta: {
            id: '10700800',
            title: '密码重置审批'
          },
          component: () => import('@/views/accountManage/security/resetPasswordApproval/index')
        },
        // U盾证书更新
        {
          path: 'update-cert',
          name: 'UpdateCert',
          meta: {
            id: 'certUpdate',
            title: 'U盾证书更新'
          },
          component: () => import('@/views/accountManage/security'),
          redirect: '/manage/security/update-cert/index',
          children: [
            {
              path: 'index',
              name: 'UpdateCertIndex',
              component: () => import('@/views/accountManage/security/updateCert/index')
            },
            {
              path: 'down',
              name: 'UpdateCertDown',
              component: () => import('@/views/accountManage/security/updateCert/down')
            },
            {
              path: 'result',
              name: 'UpdateCertResult',
              component: () => import('@/views/accountManage/security/updateCert/result')
            }
          ]
        },
        // 操作日志查询
        {
          path: 'query-log',
          name: 'QueryLog',
          meta: {
            id: '99992000',
            title: '操作日志查询'
          },
          component: () => import('@/views/accountManage/security'),
          redirect: '/manage/security/query-log/list',
          children: [{
            path: 'list',
            name: 'QueryLogList',
            component: () => import('@/views/accountManage/security/queryLog/QueryLogList')
          }]
        }
      ]
    }
  ]
}
